import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A CLEAR SYSTEM.', 'VISUAL INSTRUCTIONS.', 'BETTER CONTROL.', 'HEALTHIER PLANTS.', 'FASTER PROBLEM SOLVING.', 'MORE CONFIDENCE.'];
const alreadyHave = ['You already have the setup process.', 'You already have the nutrient references.', 'You already have the crop guides.', 'You already have the root visuals.', 'You already have the lighting guidance.', 'You already have the troubleshooting process.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-cream border-y border-sage-200" data-id="element-55" data-mp="18o0fbzj2fdpm">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-56" data-mp="18m5usmbphnm2">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-forest mb-6 uppercase" data-id="element-57" data-mp="1wdb56lyvnnoz">
          You Don&apos;t Need More Random Hydroponic Information.
        </h2>
        <p className="text-xl text-charcoal/80 mb-5" data-id="element-58" data-mp="28wyasxr6mnl4">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-59" data-mp="28zar76hakpw2">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-leaf tracking-wide" data-id="element-60" data-mp="1v3yvavregtdk">
              {need}
            </li>)}
        </ul>
        <div className="bg-sage-50 border border-sage-200 rounded-2xl p-8 text-lg text-charcoal space-y-2 text-left sm:text-center" data-id="element-61" data-mp="1l6u60n29chsj">
          <p className="mb-4" data-id="element-62" data-mp="1q4c9hxxia4t5">
            With Hydroponics Grower Ready... you don&apos;t start every problem with another
            internet search.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-forest font-semibold flex items-center sm:justify-center gap-2" data-id="element-63" data-mp="36kynzshnta84">
              <Check size={18} className="text-leaf shrink-0" aria-hidden="true" data-id="element-64" data-mp="3biqganm7uycu" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-65" data-mp="393a70lv058kl">And with the complete 6-in-1 system:</p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-forest" data-id="element-66" data-mp="35301tbf1am6s">
            YOU ALREADY HAVE <span className="text-leaf" data-id="element-67" data-mp="30588qe2nku10">THE ROADMAP.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}